import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AppConfigService } from './app-config.service';
import {map} from 'rxjs/operators';
import {Register} from '../models/register';
import { Observable } from 'rxjs';

@Injectable()
export class CompteService {
    private apiUrl: string;

    constructor(private http: HttpClient, private _appConfig: AppConfigService) {
        this.apiUrl = _appConfig.config.servicesBaseUrl;
    }

    getById(id: number) {
        return this.http.get(this.apiUrl + `/cpt/` + id);
    }

    checkMobileMissing(compteKey: number) {
        return this.http.get(this.apiUrl + `/cpt/` + compteKey + `/compte-information-missing`);
    }

    updateMobile(mobile: string, compteKey: number) {
        const data = {
            'mobile': mobile
        };
        return this.http.put<string>(this.apiUrl + `/cpt/` + compteKey + `/update-mobile`, data)
            .pipe(map(cpt => {
                return cpt;
            }));
    }

    updateEmail(email: string, compteKey: number) {
        const data = {
            'email': email
        };
        return this.http.put<any>(this.apiUrl + `/cpt/` + compteKey + `/update-email`, data)
            .pipe(map(cpt => {
                return cpt;
            }));
    }

    updateNewsletter(newsletters: boolean, compteKey: number) {
        const data = {
            'newsletters': newsletters
        };
        return this.http.put<any>(this.apiUrl + `/cpt/` + compteKey + `/update-newsletters`, data)
            .pipe(map(cpt => {
                return cpt;
            }));
    }

    checkPassword(password: string, compteKey: number) : Observable<any> {
        const data = {
            'password': password
        };
        return this.http.put<any>(this.apiUrl + `/cpt/` + compteKey + `/check-password`, data)
            .pipe(map(c => {
                return c;
            }));
    }

    updatePassword(password: string, compteKey: number) {
        const data = {
            'password': password
        };
        return this.http.put<any>(this.apiUrl + `/cpt/` + compteKey + `/update-password`, data)
            .pipe(map(cpt => {
                return cpt;
            }));
    }

    getPatientsAffiliated(compteKey: string) {
        return this.http.get<any>(this.apiUrl + `/cpt/` + compteKey + `/patients`)
            .pipe(map(pat => {
                return pat;
            }));
    }

    register(register: Register) {
        return this.http.post(this.apiUrl + `/cpt/register`, register);
    }

    unregister(compteKey: number) {
        return this.http.post(this.apiUrl + `/cpt/unregister/` + compteKey, { })
            .pipe(map(ret => {
                return ret;
            }));
    }

    forgetPassword(email: string) {
        return this.http.post<any>(this.apiUrl + `/cpt/forgot-password`, { email: email })
            .pipe(map(data => {
                return data;
            }));
    }

    validationCGU(compteKey: number, cgu: boolean, arm: boolean) {
        const data = {
            compteKey: compteKey,
            cgu: cgu,
            arm: arm
        };
        return this.http.post<any>(this.apiUrl + `/cpt/valid-cgu`, data)
            .pipe(map(c => {
                return c;
            }));
    }

    askUpdateEmail(compteKey: number, email: string) {
        return this.http.post(this.apiUrl + `/cpt/` + compteKey + `/ask-update-email`, { email: email})
            .pipe(map(ret => {
                return ret;
            }));
    }

    askUpdateMobile(compteKey: number, mobile: string) {
        return this.http.post(this.apiUrl + `/cpt/` + compteKey + `/ask-update-mobile`, { mobile: mobile})
            .pipe(map(ret => {
                return ret;
            }));
    }

    validateUpdateEmail(compteKey: number, codeOtp: string, email: string) {
        return this.http.put<any>(this.apiUrl + `/cpt/` + compteKey + `/validate-update-email`, {codeOtp: codeOtp, email: email})
            .pipe(map(cpt => {
                return cpt;
            }));
    }

    validateUpdateMobile(compteKey: number, codeOtp: string, mobile: string) {
        return this.http.put<any>(this.apiUrl + `/cpt/` + compteKey + `/validate-update-mobile`, {codeOtp: codeOtp, mobile: mobile})
            .pipe(map(cpt => {
                return cpt;
            }));
    }
}
